import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close--sprite",
  "use": "close--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close--sprite\">\n<g>\n<path fill=\"currentColor\" d=\"M13.3 11.9L17.5 7.7C17.9 7.3 17.9 6.7 17.5 6.3C17.1 5.9 16.5 5.9 16.1 6.3L11.9 10.5L7.7 6.3C7.3 5.9 6.7 5.9 6.3 6.3C5.9 6.7 5.9 7.3 6.3 7.7L10.5 11.9L6.3 16.1C5.9 16.5 5.9 17.1 6.3 17.5C6.7 17.9 7.3 17.9 7.7 17.5L11.9 13.3L16.1 17.5C16.5 17.9 17.1 17.9 17.5 17.5C17.9 17.1 17.9 16.5 17.5 16.1L13.3 11.9Z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol